import LogoMini from "../../../components/icons/LogoMini";
import PlayTriangle from "../../../components/icons/PlayTriangle";
import "../general.scss";
import "./index.scss";
import Retail from "../../../assets/img/SolutionsIcons/AgilysysRetail.svg";
import { Header } from "../../../components/Header";

const RetailFPage = () => {
    return (
      <div className="page splash retailFPage">
        <div className="page-title">
          <img src={Retail} alt="" />
        </div>
        <Header />
        <div className="text-blocks">
          <div className="std-text">
            Our POS solution supports retail item sales for spas, pro shops,
            gift shops, and more that don’t require a full enterprise POS
            system. Easily set up and track inventory, or sell items to
            residents as part of other services.
          </div>
        </div>
        {/*<div className="play-video" onClick={()=>setShowVideo(true)}>
                <PlayTriangle />
                Play Video
            </div>*/}
        <img
          className="img-1"
          src={
            "https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/Retail1.png"
          }
          alt=""
        />
      </div>
    );
}

export default RetailFPage;